<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<link rel ="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"></link>
<template>
  <v-container>
    <v-layout text-center wrap>
      <span id="main_title">
        <span id="main_title_text">
          <h4>メッセージ一覧</h4>
        </span>
      </span>
      <span id="header_logo"><img src="https://misemeg.jp/appli/img/misemeg-logo.svg" width="49px" /></span>
      <span id="window_close" @click="returntop"><i class="fa fa-angle-double-left fa-3x fa-fw"
          title="TOP画面に戻る"></i></span>
      <v-flex xs12>
        <!-- <h1>ようこそ！ {{ name }} <b>{{ email }}</b> {{ userId }}さん</h1> -->
        <!-- <h3><v-btn large color="error" @click="logout">ログアウト</v-btn></h3> -->
        <!-- <img src='https://misemeg.jp/owner/mb/assets/images/common/misemeg_icon.svg' height="100px" width="100px"> -->
        <!-- <h4>LINEミニアプリ "みせめぐMini"</h4> -->
        <!-- <br /> -->
        <br />
        <span id="push_info"><a href="https://test.misemegu.jp/appli/Install.php?shopid=NjUxMTM5&dflg=MA=="
            target="_blank">※プッシュ通知を受信するためには<br />&emsp;&emsp;スマホ版みせめぐアプリが必要です</a></span>
        <br />
        <br />
        <span id="reload_btn_small" @click="reload_pmlist()"><i
            class="fa-solid fa-arrows-rotate fa-lg"></i>&ensp;再読み込み</span>
        <br />
        <!-- <v-btn large color="success" @click="returntop" title="ＴＯＰ画面に戻る" id="returntop_btn">ＴＯＰ画面に戻る</v-btn> -->
        <!-- <v-btn large color="success" @click="returntop" title="デジタル会員証" id="returntop_btn">会員バーコード</v-btn> -->
        <span id="messages_info"></span>
        <br /><br />
        <span id="misemeg_uid" hidden></span>
        <span id="member_info" hidden></span>
      </v-flex>
      <br />
      <br />
      <!-- Snackbar -->
      <div>
        <v-snackbar v-model="snackbarFlag" color="primary" multi-line :timeout="snackbarTimeout" top>
          {{ snackbarText }}
        </v-snackbar>
      </div>
      <br />
      <br />
      <v-flex mb-4 xs12>
        <br /><br />
        <div class="ma-4">
          <span id="copyright"><a href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1"
              target="_blank">&emsp;みせめぐ&nbsp;&times;&nbsp;LINEミニアプリ&emsp;<br />&emsp;Copyright &copy;
              BUSICOM.Co.,ltd. </a><br />&emsp;v2.5.0.1&emsp;</span>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
 .v-main{
  background-color:#f3f3f3;
  text-align: center;
  }
 #main_title {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00843f;
  color: #ddd;
  width: 100%;
  height: 70px;
  letter-spacing: 0.3em;
  margin-top: -12px;
  margin-left: -12px;
  margin-right: -50px;
}
#main_title_text {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.3em;
  margin-top: 0px;
  margin-left: -10px;
  margin-right: 0px;
}

 #header_logo{
  height:70px;
  display:flex;
  justify-content: center;
  align-items: center;
  margin-top:-70px;
  margin-left:0px;
  margin-right:100px;
 }
 #storeslist_tbl{
  display:fixed;
  margin: 0 auto;
  border-collapse:collapse;
  border:0px solid #000; 
  background-color:#f3f3f3;
  width: 100%;
 }
 #storeslist_tbl tr{
  line-height:20px;  
 }
 #storeslist_tbl td{
  border-collapse:collapse;
  border:0px solid #000; 
  background-color:#f3f3f3;
  text-align:left;
  padding: 0; 
 }
 #storeslist_tbl td a{
  text-decoration: none;
 }
 #push_info{
  color:brown;
  font-size:middle;
  padding:5px;
  text-decoration: none;
 }
 #push_info a {
  color: brown;
  text-decoration: none;
 }
 #returntop_btn{
  width:50%;
  font-size:large;
 }
 #window_close {
   margin-top: -58px;
   padding-left: 84%;
   color: #f3f3f3;
 }
 .std_row{
  background-color:#f3f3f3;
 }
 .title_row{
  background-color:#f3f3f3;
 }
 #line_logout{
  margin: 0 auto;
 }
 #copyright{
  margin: 0 auto;
  color:#88b3b3;
  text-decoration: none;
 }
 #copyright a{
  margin: 0 auto;
  color:#88b3b3;
  text-decoration: none;
 }
 hr {
    height: 3px;
    border: 0;
    border-color : #00843f;
    box-shadow: inset 0 12px 12px -12px rgba(168,168,168,0.7);
 }
 .push_warning_row{
    display:flex;
    text-align: center;
    white-space: nowrap;
    justify-content: center;
    align-items: center;
    background-color:#f3f3f3;
    color:red;
 }
 #pushlist_tbl{
  display:fixed;
  margin: 0 auto;
  border-collapse:collapse;
  border:0px solid #000; 
  background-color:#f3f3f3;
  width: 100%; 
  text-align: left;
 }
 #pushlist_tbl tr{
    line-height:20px; 
    line-height: 1.8em;
    border-bottom: #00843f 1px solid;
 }
 .pushlist_column{
  border-collapse:collapse;
  border:0px solid #00ffbd; 
  background-color:#00ffdf;
  color:#333;
  text-align:left;
  padding: 0; 
 }
#reload_btn_small {
  width: 65%;
  font-size: middle;
  letter-spacing: 0.1em;
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  margin:0 auto;
  color:#00843f;
  background-color:#eee;
}
</style>
<script>
// for encrypt message
import crypto from 'crypto-js';
var CryptoJS = require('crypto-js');
// var dts = new Date().getDate();
var dts = '651127';
var passPhrase = "45b54c392cc235a79ce573f623b2f8023" + dts + "d6dd6edf2488805962a3d223be6566b";
const salt = CryptoJS.lib.WordArray.random(128 / 8);
const iv = CryptoJS.lib.WordArray.random(128 / 8);
const key = "0921b90b3b7dab492b4aa897e3d0ccffde0f59579fc0c6229213c" + dts + "94822466ce8";

// for HTTP response
import axios from 'axios'

export default {
  data () {
    return {
      snackbarFlag: false,
      snackbarTimeout: 3000,
      snackbarText: '',
      name: '',
      imgURL: '',
      userId: '',
      email: '',
      barcode_url: '',
      inClient: false
    }
  },
  created () {
    this.initializeLiff();
    //window.alert('page loaded');
  },
  mounted() {
    $('#main_title').css('width',window.outerWidth);
    ;;
  },
  methods: {
    
    initializeLiff: function () {
      var me = this
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID
        },
        data => {
          me.loginCheck()
        },
        err => {
          console.log('LIFF initialization failed', err)
        }
      )
    },
    loginCheck: async function () {
      var me = this;
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid=this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if(debug_mode == '2'){
        miseid=this.$_shopid();
      }
      // 0016891 20240918 "liff init failure"エラーの対策で liff.ready の処理を追記
      liff.ready.then(() => {
      // ログインチェック      
      if (liff.isLoggedIn()) {
        this.isClient = liff.isInClient();
        const permissionStatus = liff.permission.query("email");
        debugger;
        if (permissionStatus.state === "prompt") {
            liff.permission.requestAll();
        }
       
       const idToken = liff.getDecodedIDToken();
       console.log(idToken); // print decoded idToken object

        var email = idToken.email;
        //idToken からメールが取得出来ない場合はlocalStorageに保存したメルアド情報を取得する
        try{
          if(email=='undefined'||email==null||email==''){
             var encrypted_mail = localStorage.getItem('lmmini_' + dts + '_maddr');
            //  window.alert(encrypted_mail);
             var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, {iv: iv,});
            //  window.alert(dec_email);
             email = dec_email.toString(CryptoJS.enc.Utf8);
            //  window.alert(email);
          } 
        }catch(Exception){
           email = '';
        }
       
      // プロフィール取得
      liff.getProfile()
        .then(profile => {
          me.name   = profile.displayName
          me.imgURL = profile.pictureUrl
          me.userId = profile.userId
          me.email  = email            
          //me.barcode_img = barcode_url
          debugger;            
        })
        .catch((err) => {
          console.log('error', err)
        })
        // md5()実行用ライブラリ読込
        var md5 = require('md5');
        // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく(午前ゼロ時をまたいでエラーになるケースはいったん無視する）
        var dt = new Date();
        var year = dt.getFullYear();
        var month = dt.getMonth()+1;
        var strMonth='';
        if(month<10){
          strMonth = '0' + month;
        }else{
          strMonth = month.toString();
        }
        var date = dt.getDate();
        var strDate = '';
        if(date<10){
          strDate = '0' + date;
        }else{
          strDate = date.toString();
        }
        var mmddyyyy= strMonth + '-' + strDate + '-' + year;
        //----------------------------------------------------------
        // <0> 登録時に選択した店舗IDの情報がWebStorageにあれば取得する
        //----------------------------------------------------------
        //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
        var g_miseid=this.$_t_shopid();
        //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
        var debug_mode = this.$_debug_mode();
        if(debug_mode == '2'){
          g_miseid=this.$_shopid();
        }
        var encrypted_myshopid = localStorage.getItem('lmmini_' + dts + '_myshopid');
        if(encrypted_myshopid){
          const dec_encrypted_myshopid = CryptoJS.AES.decrypt(encrypted_myshopid, key, {iv: iv,});
          var myshopid = dec_encrypted_myshopid.toString(CryptoJS.enc.Utf8);
          if(myshopid){
            miseid=myshopid;
          }else{
            miseid=g_miseid;
          }
        }else{
          miseid=g_miseid;
        }
        //---------------------------
        // みせめぐUserIDの取得
        //---------------------------
        // （１）メルアドに対応するみせめぐユーザーIDを取得する（※すでにアプリでUIDを持っているか否かを判断するのに使用）
        // var misemeg_uid = '';
        var getuid_url ="";
        //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
        var i_shopid=Number(this.$_shopid());
        if(debug_mode=='0'){
          getuid_url = this.$_debug_url();
        }else if(debug_mode=='2'){
          if(i_shopid % 2 == 0){
            getuid_url = "https://sv2.misemeg.jp/";
          }else{
            getuid_url = "https://sv1.misemeg.jp/";
          }
        }else{
          if(i_shopid % 2 == 0){
            getuid_url = "https://sv2.misemegu.jp/";
          }else{
            getuid_url = "https://sv1.misemegu.jp/";
          }
        }
        getuid_url += "appli/line/";
        getuid_url += "getMisemegUID.php?mail=";
        getuid_url += email;
        getuid_url += "&security=" + md5(email + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + email + "!Busicom04510" +
        mmddyyyy);
        // window.alert('getMemInf = ' + getuid_url);
        axios.get(getuid_url)
        .then((response) => document.getElementById('misemeg_uid').innerHTML = response.data)
        // .then((response) => misemeg_uid = response.data)
        .catch(error => console.log(error))
        ;
        
        //----------------------------
        // PUSH通知一覧情報の取得と表示
        //----------------------------
        var codeinfo_url ="";
        //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
        var i_shopid=Number(this.$_shopid());
        if(debug_mode=='0'){
          codeinfo_url = this.$_debug_url();
        }else if(debug_mode=='2'){
          if(i_shopid % 2 == 0){
            codeinfo_url = "https://sv2.misemeg.jp/";
          }else{
            codeinfo_url = "https://sv1.misemeg.jp/";
          }
        }else{
          if(i_shopid % 2 == 0){
            codeinfo_url = "https://sv2.misemegu.jp/";
          }else{
            codeinfo_url = "https://sv1.misemegu.jp/";
          }
        }
        /*
        http://localhost:83/mg/appli/line/getPushMessagesHTML.php
        ?mail=YmNpaWppbWFAZ21haWwuY29t
        &pid=NDMyNw%3D%3D
        &sid=NjUxMTU0
        &uid=dTA0MDQ1MDk%3D
        &unread=MA%3D%3D
        &security=5821abbc2210a3b13ea58e0613ca63e8
        &submit=PUSH%E9%80%9A%E7%9F%A5%E4%B8%80%E8%A6%A7%E3%81%AE%E5%8F%96%E5%BE%97
        */
        // ---- PC debug ----   
        // codeinfo_url = "http://localhost:83/mg/appli/line/";
        // ------------------
        //オーナーIDをグローバル変数から取得する（※初期値は試験用）
        var prmid=this.$_t_prmid();
        //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
        if(debug_mode == '2'){
          prmid=this.$_prmid();
        }
        var misemeg_uid = document.getElementById('misemeg_uid').innerHTML;
        codeinfo_url += "appli/line/";
        // alert("misemeg_uid=" +  misemeg_uid);
        codeinfo_url += "getPushMessagesHTML.php?mail=";
        codeinfo_url += btoa(email);
        codeinfo_url += "&pid=";
        codeinfo_url += btoa(prmid);
        codeinfo_url += "&sid=";
        codeinfo_url += btoa(miseid);
        codeinfo_url += "&uid=";
        codeinfo_url += btoa(misemeg_uid);
        codeinfo_url += "&unread=MA%3D%3D";
        codeinfo_url += "&security=" + md5(email + "5ca968c5c9c793ad75b49ac19b493ad2misemeg" + email + "!Busicom04510" + mmddyyyy); 
        codeinfo_url += "&bgc=" + btoa("#00843f") + "&clr=" + btoa("#ddd") + "&dbg=" + btoa(debug_mode);
        codeinfo_url += "&submit=PUSH%E9%80%9A%E7%9F%A5%E4%B8%80%E8%A6%A7%E3%81%AE%E5%8F%96%E5%BE%97";    
        //window.alert(codeinfo_url); 
        axios.get(codeinfo_url)
        //.then((response) => this.users = response.data)
        .then((response) => document.getElementById('messages_info').innerHTML = response.data)
        .catch(error => console.log(error))
        ;
        debugger;
      } else {
        // ログインまだ
        // this.$router.push({ name: 'home' })
      }
      }); // end of  linff.ready.then
    },
    logout: function () {
      // ログアウト
      if (liff.isLoggedIn()) {
        liff.logout()
        this.$router.push({ name: 'home' })
      }
    },
    returntop: function () {
      if (liff.isLoggedIn()) {
        // line-mini トップ画面に戻る      
        this.$router.push({ name: 'login' });
      }
    },
    showSnackbar(text) {
      this.snackbarFlag = true
      this.snackbarText = text
      setTimeout(()=> {
          this.snackbarFlag = false
          this.snackbarText = ''
        },
        this.snackbarTimeout
      )
    },
    reload_pmlist: function(){
      // 同一画面の再読み込みは$router.go({path},force:true)
      // this.$router.go({path: 'pm_list', force: true});
      window.location.href = '/648368/?start=6';
    },
    getBarcodeParam(){
      md5()
    }
    
  }
}
</script>